import { apiClient } from "./client";

// ---- Entity listings ----

export async function fetchAdminProfessionals() {
  const res = await apiClient.get("/admin/professionals");
  return res.data;
}

export async function fetchAdminInstitutions() {
  const res = await apiClient.get("/admin/institutions");
  return res.data;
}

export async function fetchAdminInstitutionById(id) {
  const res = await apiClient.get(`/admin/institutions/${id}`);
  return res.data;
}

export async function fetchAdminOrganisations() {
  const res = await apiClient.get("/admin/organisations");
  return res.data;
}

export async function fetchAdminOrganisationById(id) {
  const res = await apiClient.get(`/admin/organisations/${id}`);
  return res.data;
}

export async function fetchAdminVerifications() {
  const res = await apiClient.get("/admin/verifications");
  return res.data;
}

export async function fetchAdminRevenue() {
  const res = await apiClient.get("/admin/finance/revenue");
  return res.data;
}

export async function fetchAdminPayouts() {
  const res = await apiClient.get("/admin/finance/payouts");
  return res.data;
}

/**
 * Records a payout made to one verifier: the ledger entries it covered, the
 * bank transfer's reference and the day it was sent (YYYY-MM-DD). Resolves
 * to { reference, paidOn, settledCount, netPaise, alreadyRecorded }.
 */
export async function recordPayout({ entryIds, reference, paidOn }) {
  const res = await apiClient.post("/admin/finance/payouts/settle", {
    entryIds,
    reference,
    paidOn,
  });
  return res.data;
}

// ---- Pending org queue ----

export async function fetchPendingOrgs() {
  const res = await apiClient.get("/admin/pending-organisations");
  return res.data;
}

export async function approveInstitution(id, note) {
  const res = await apiClient.post(`/admin/institutions/${id}/approve`, {
    note,
  });
  return res.data;
}

export async function rejectInstitution(id, reason) {
  const res = await apiClient.post(`/admin/institutions/${id}/reject`, {
    reason,
  });
  return res.data;
}

export async function approveOrganisation(id, note) {
  const res = await apiClient.post(`/admin/organisations/${id}/approve`, {
    note,
  });
  return res.data;
}

export async function rejectOrganisation(id, reason) {
  const res = await apiClient.post(`/admin/organisations/${id}/reject`, {
    reason,
  });
  return res.data;
}

// ---- Stats ----

export async function fetchAdminStats() {
  const res = await apiClient.get("/admin/stats");
  return res.data;
}

// ---- Audit log ----

export async function fetchAuditLog(filters = {}) {
  const res = await apiClient.get("/admin/audit-log", { params: filters });
  return res.data;
}

// ---- User suspensions ----

export async function suspendUser(id, reason) {
  const res = await apiClient.post(`/admin/users/${id}/suspend`, { reason });
  return res.data;
}

export async function unsuspendUser(id) {
  const res = await apiClient.post(`/admin/users/${id}/unsuspend`, {});
  return res.data;
}

// ---- Organisation Coupons ----

export async function fetchOrgCoupons(orgId) {
  const res = await apiClient.get(`/admin/organisations/${orgId}/coupons`);
  return res.data;
}

export async function createOrgCoupon(orgId, data) {
  const res = await apiClient.post(
    `/admin/organisations/${orgId}/coupons`,
    data,
  );
  return res.data;
}

export async function toggleOrgCoupon(orgId, couponId) {
  const res = await apiClient.post(
    `/admin/organisations/${orgId}/coupons/${couponId}/toggle`,
    {},
  );
  return res.data;
}

// ---- Academic Institution Coupons ----

export async function fetchInstitutionCoupons(instId) {
  const res = await apiClient.get(`/admin/institutions/${instId}/coupons`);
  return res.data;
}

export async function createInstitutionCoupon(instId, data) {
  const res = await apiClient.post(
    `/admin/institutions/${instId}/coupons`,
    data,
  );
  return res.data;
}

export async function toggleInstitutionCoupon(instId, couponId) {
  const res = await apiClient.post(
    `/admin/institutions/${instId}/coupons/${couponId}/toggle`,
    {},
  );
  return res.data;
}

// ---- Platform Onboarding Coupons ----

export async function fetchAdminCoupons(params = {}) {
  const res = await apiClient.get("/admin/coupons", { params });
  return res.data;
}

export async function createAdminCoupon(data) {
  const res = await apiClient.post("/admin/coupons", data);
  return res.data;
}

export async function toggleAdminCoupon(couponId) {
  const res = await apiClient.post(`/admin/coupons/${couponId}/toggle`, {});
  return res.data;
}

export async function deleteAdminCoupon(couponId) {
  const res = await apiClient.delete(`/admin/coupons/${couponId}`);
  return res.data;
}

// ---- Entity Location Updates ----

export async function updateAdminInstitutionLocation(id, location) {
  const res = await apiClient.patch(`/admin/institutions/${id}/location`, {
    location,
  });
  return res.data;
}

export async function updateAdminOrganisationLocation(id, location) {
  const res = await apiClient.patch(`/admin/organisations/${id}/location`, {
    location,
  });
  return res.data;
}

export async function updateAdminOrganisationOfficerPrice(id, priceRupees) {
  const res = await apiClient.patch(`/admin/organisations/${id}/officer-price`, {
    priceRupees: Number(priceRupees),
  });
  return res.data;
}

export async function updateAdminInstitutionOfficerPrice(id, priceRupees) {
  const res = await apiClient.patch(`/admin/institutions/${id}/officer-price`, {
    priceRupees: Number(priceRupees),
  });
  return res.data;
}
